import { combineReducers } from "redux";
import { cartReducer } from "./cartReducer";
import { CODReducer } from "./CODReducer";
import { couponReducer } from "./couponReducer";
import { drawerReducer } from "./drawerReducer";
import { searchReducer } from "./searchReducer";
import userReducer from './userReducer';
import { businessReducer } from './businessReducer';  // NEW: Business state (May 2025)



const rootReducer = combineReducers({
  user:userReducer,
  search: searchReducer,
  cart: cartReducer,
  drawer: drawerReducer,
  coupon: couponReducer,
  COD: CODReducer,
  business: businessReducer,  // NEW: Business state

})


export default rootReducer;
